import { lazy } from "react";

/*
 * The knowledge feature's public surface. Outside code imports only from here.
 * The pages are lazy, so the button on Faults/Diagnostics does not pull them and the PDF viewer in with it.
 */
export const KnowledgeHomePage = lazy(() => import("./pages/knowledge-home-page"));
export const KnowledgeExtractStartPage = lazy(() => import("./pages/extract-start-page"));
export const KnowledgeExtractionWorkspacePage = lazy(() => import("./pages/extraction-workspace-page"));
export const KnowledgeManualExtractionPage = lazy(() => import("./pages/manual-extraction-page"));
export const KnowledgeContinuePage = lazy(() => import("./pages/continue-page"));
export { default as KnowledgeOldAddressRedirect } from "./pages/old-address-redirect";
export { default as KnowledgeBaseButton } from "./components/knowledge-base-button";
// Lazy too: opening a manual page from it pulls in the PDF viewer.
export const FaultsDiagnosticsList = lazy(() => import("./components/faults-diagnostics-list"));
export { KNOWLEDGE_BASE_PATH, KNOWLEDGE_CONTINUE_PATH, KNOWLEDGE_EXTRACT_PATH } from "./paths";
